export default __webpack_public_path__ + "static/media/trendyol.4f39e467.svg";